import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { ModalResponsavelComponent } from '../../modal-responsavel/modal-responsavel.component';
import { IndicadoresProjeto } from '../../models/indicadores-projeto.model';
import { IndicadoresPgAtividadeService } from '../../services/indicadores-pg-atividade.service';
import { IndicadoresPgService } from '../../services/indicadores-pg.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-detalhe-pg-indicadores-list',
  templateUrl: './detalhe-pg-indicadores-list.component.html',
  styleUrls: ['./detalhe-pg-indicadores-list.component.scss']
})
export class DetalhePgIndicadoresListComponent extends BaseListComponent<IndicadoresProjeto> implements OnInit, OnDestroy {

  idPg: number;
  indicadoresList: IndicadoresProjeto[];
  ordenacao: boolean;
  permission: any;
  type: string = '';

  @ViewChild("modalResonsavel") modalResonsavel: ModalResponsavelComponent;

  constructor(private myService: IndicadoresPgService,
    private atividadeService: IndicadoresPgAtividadeService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.idPg = Number(this.router.routerState.snapshot.url.replace(/\D/g, ''));
    this.type = this.activatedRoute.snapshot.data['type'];
    this.initList();

    this.addSub(EventSharedService.get('loading').subscribe(() => {
      this.loading();
    }))
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initList(obj = null) {
    this.addSub(
      this.myService.getList(this.idPg, obj).subscribe({
        next: (res) => {
          this.indicadoresList = res['list'];
          this.permission = res['permission'];
          this.loaded();
        },
        error: (err) => {
          this.loaded();
        },
      })
    )
  }

  drop(event: CdkDragDrop<string[]>) {
    this.ordenacao = true;
    moveItemInArray(this.indicadoresList, event.previousIndex, event.currentIndex);
    this.indicadoresList.forEach((item, index) => {
      item.nro_ord = index + 1;
    })
  }

  novo() {
   return ['/projetos', this.type ?? 'agregador', 'indicadores', this.idPg, 'adicionar'];
  }

  getDataCreateOrder(): any {
    return {
      pf_ind_order: this.indicadoresList.map((item) => {
        return { id: item.id, nro_ord: item.nro_ord };
      })
    }
  }

  salvarOrdem() {
    this.loading();
    this.ordenacao = false;

    this.addSub(
      this.myService.salvarOrdem(this.getDataCreateOrder()).subscribe({
        next: (res) => {
          this.msgSuccess("Ordem Salva com Sucesso!");
          this.loaded();
        },
        error: (err) => {
          this.msgError(err?.error?.message);
          this.loaded();
        },
      })
    )
  }

  viewIndicador(id: number) {
   return ['/projetos', this.type ?? 'agregador', 'indicadores', id];
  }

  viewInfo(indicador: IndicadoresProjeto) {
    if (indicador?.viewInfoActive) {
      indicador.viewInfoActive = false;
      return;
    }

    this.loading();
    this.addSub(
      this.atividadeService.getListAll(indicador?.id).subscribe({
        next: (res) => {
          if (res['actions']?.length) {
            indicador.action = res['actions'];
          }
          this.loaded();
        },
        error: (err) => {
          this.loaded();
        },
      })
    );

    this.myService.graphTable(indicador?.ind_goal_id).subscribe({
      next: (value) => {
        if (value) {
          indicador.chartOptions = {
            responsive: true,
          };
          indicador.chartLabels = [];
          indicador.chartData;
          indicador.chartType = value?.type_graph == 2 ? 'line' : 'bar';
          indicador.chartMeta = [];
          indicador.chartRealizado = [];

          value.itens.forEach((item, index) => {
            if (index != 0) {
              indicador.chartLabels.push(item[0]);
              indicador.chartMeta.push(item[1]);
              indicador.chartRealizado.push(item[2]);
            }
          })

          indicador.chartData = {
            labels: indicador.chartLabels,
            datasets: [
              {
                data: indicador.chartMeta,
                label: value.itens[0][1],
                pointRadius: 5,
              },
              {
                data: indicador.chartRealizado,
                label: value.itens[0][2],
                pointRadius: 5,
              },
            ],
          };
        }
        indicador.viewInfoActive = true;
        this.loaded();
      },
      error: (err) => {
        indicador.viewInfoActive = true;
        this.msgError(err?.error?.message);
        this.loaded();
      },
    })
  }

  viewResonsavel(indicador: IndicadoresProjeto) {
    this.modalResonsavel.openModal([indicador, ...indicador?.resp_adj]);
  }
}
